import type { CSSProperties, ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  /** Removes the inner padding, for cards that hold their own list rows. */
  flush?: boolean;
  style?: CSSProperties;
}

export function Card({ children, flush = false, style }: CardProps) {
  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)',
        boxShadow: 'var(--shadow-card)',
        padding: flush ? 0 : 'var(--sp-5)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
